import { useState } from 'react';
import Header from '@/components/common/Header';
import AffiliateGeneralSetting from './AffiliateGeneralSetting';
import AffiliateCommissionSlabs from './AffiliateCommissionSlabs';
import AddCommissionSlabModal from './AddCommisionSlabModal';

type TabType = 'general' | 'slabs';

const AffiliateSetting = () => {
  const [activeTab, setActiveTab] = useState<TabType>('general');
  const [openModal, setOpenModal] = useState(false);

  const handleButtonClick = () => {
    setOpenModal(true);
  };

  return (
    <div className="padding">
      <Header
        title="Affiliate Settings"
        showButton={activeTab === 'slabs'}
        buttonLabel="+ Add New Slabs"
        onButtonClick={handleButtonClick}
      />

      {/* Tabs */}
      <div className="flex gap-2 my-6 bg-[#BEFFBE] rounded-md w-fit p-2">
        {['general', 'slabs'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab as TabType)}
            className={`px-4 py-1.5 rounded-md text-sm border text-black ${
              activeTab === tab ? 'bg-[#EAFFED] border-green font-semibold' : 'border-none'
            }`}
          >
            {tab === 'general' ? 'General Settings' : 'Commission Slabs'}
          </button>
        ))}
      </div>

      {activeTab === 'general' && <AffiliateGeneralSetting />}
      {activeTab === 'slabs' && <AffiliateCommissionSlabs />}

      {/* Modal */}
      <AddCommissionSlabModal open={openModal} onClose={() => setOpenModal(false)} />
    </div>
  );
};

export default AffiliateSetting;
